var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout",class:_vm.layoutClasses},[_c('Header'),(_vm.$mq !== 'mobile')?_c('div',{staticClass:"sidebar"},[_c('Feed')],1):_vm._e(),_c('div',{staticClass:"content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }